import { useEffect, useState } from 'react';
import { performanceApi, type PerformanceAccountSummary, ApiError } from '@/services/api';
import { usePerformanceContext } from '../../PerformanceContext';

interface State {
  data: PerformanceAccountSummary | null;
  loading: boolean;
  error: string | null;
}

export function useAccountSummary() {
  const { clientUid, dateFrom, dateTo } = usePerformanceContext();
  const [state, setState] = useState<State>({ data: null, loading: false, error: null });

  useEffect(() => {
    if (!clientUid) return;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));

    performanceApi
      .getAccountSummary({ clientUid, dateFrom, dateTo })
      .then((data) => {
        if (cancelled) return;
        setState({ data, loading: false, error: null });
      })
      .catch((err) => {
        if (cancelled) return;
        const msg = err instanceof ApiError ? err.body : String(err);
        setState({ data: null, loading: false, error: msg });
      });

    return () => {
      cancelled = true;
    };
  }, [clientUid, dateFrom, dateTo]);

  return state;
}
